import { styled } from 'baseui'
import { ourColors } from './Colors'

export const HorizontalLine = styled('hr', () => ({
  background: ourColors.interfaceGrey
}))
